var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 control-section"},[_c('div',{staticClass:"tree-control-wrapper"},[_c('ejs-treeview',{ref:"seatTree",attrs:{"id":"seatTree","fields":_vm.fields,"showCheckBox":true,"nodeChecked":_vm.nodeChecked}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }